import React, { useState, createContext } from 'react';
import OTPInput from './SignUp/OTPInput/OTPInput';
import SignUpSeeker from './SignUp/SignUpSeeker/SignUpSeeker';
import SignUpPoster from './SignUp/SignUpPoster/SignUpPoster';
import ChooseClient from './SignUp/ChooseClient/ChooseClient';
import SignUpDetails from './SignUp/SignUpDetails/SignUpDetails';

import styles from './signup.module.css'

// state change poster/seeker->poster/seeker->verify

//will multiple states cause re render issues to non used components ?

export const signUpContext = createContext();

export default function Signup() {
  console.log("SignUp mounted");

  const [Page, setPage] = useState('poster');
  const [next, setNext] = useState(0);//0 for choose client; 1 for signup; 2 for verify
  const [Mail, setMail] = useState('');


  const displayPage = () => {
    if (next === 0) {
      return <ChooseClient />
    }
    if (Page === 'poster' && next === 1) {
      return <SignUpPoster />
    }
    if (Page === 'seeker' && next === 1) {
      return <SignUpSeeker />
    }
    if (next === 2) {
      return <OTPInput />
    }
    if (next === 3) {
      return <SignUpDetails />
    }
  }

  return (
    <>
      <div className={styles.signup}>
        <div className={styles.featureImage}>
        </div>
        <div className={styles.container}>
          <signUpContext.Provider value={{ Page, setPage, next, setNext, Mail, setMail }}>
            {displayPage()}
          </signUpContext.Provider>
        </div>

      </div>
    </>
  );
};
